<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/customer/auth/role/page" getKey="rows" :columns="columns">
      <template #conditions>
        <!-- label-width="68px" -->
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('juesemingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #buttonsL>
        <el-button size="mini" v-if="utils.checkPower('web_system_role_create')" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button v-if="scope.row.admin == false && utils.checkPower('web_system_role_update')" type="text" @click="yt.showEditDialog('bianji', scope.row, 'w1')">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button :loading="yt.editObj.loading" v-if="scope.row.admin == false && utils.checkPower('web_system_role_delete')" type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/customer/auth/role/delete')">{{ $t('shanchu') }}</el-button>
          </el-col>

          <el-col :span="0.1">
            <el-button :loading="yt.editObj.loading" v-if="scope.row.admin == false && utils.checkPower('web_system_role_copy')" type="text" @click="yt.showEditDialog('fuzhi', scope.row, 'w1', beforeUpdate)">{{ $t('fuzhi') }}</el-button>
          </el-col>
        </el-row>
      </template>

      <template #footer>
        <!-- 这里可以在底部填写东西 -->
      </template>
    </yi_curd_table>
    <!-- 新增 -->
    <el-dialog class="abow_dialog" :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body>
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini">
            <el-form-item :label="$t('juesemingcheng')" required>
              <el-input v-model="yt.editObj.name"></el-input>
            </el-form-item>
            <div>
              <span style="font-size: 2px; color: #989898;">{{ $t('qingzaixiafangxuanzecaidanyuanniu') }}</span>
            </div>
            <el-tabs>
              <!-- 搜索框 -->
              <el-form-item size="mini">
                <el-input :placeholder="$t('qingshuruguanjianci')" v-model="filterText"> </el-input>
              </el-form-item>
              <el-tab-pane label="Web">
                <el-tree ref="treeWeb" :data="menus[0]" show-checkbox node-key="id" :default-expand-all="false" :default-expanded-keys="expandKey(0)" :default-checked-keys="yt.editObj.menuIds" class="filter-tree" :filter-node-method="filterNode"> </el-tree>
              </el-tab-pane>
              <el-tab-pane label="App">
                <el-tree ref="treeApp" :data="menus[1]" show-checkbox node-key="id" :default-expand-all="false" :default-expanded-keys="expandKey(1)" :default-checked-keys="yt.editObj.menuIds" class="filter-tree" :filter-node-method="filterNode"> </el-tree>
              </el-tab-pane>
              <el-tab-pane label="Pad">
                <el-tree ref="treePad" :data="menus[2]" show-checkbox node-key="id" :default-expand-all="false" :default-expanded-keys="expandKey(2)" :default-checked-keys="yt.editObj.menuIds" class="filter-tree" :filter-node-method="filterNode"> </el-tree>
              </el-tab-pane>
            </el-tabs>
          </el-form>
        </div>
        <!--注意，el-dialog的slot不能写成#footer-->
        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/customer/auth/role/create', beforeAddOrUpdate)" type="primary">{{ $t('baocun') }} </el-button>
        </template>
      </template>
      <!-- 编辑 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <!-- <el-tree :data="treeList(1)" show-checkbox node-key="id" :default-expanded-keys="[2, 3]"
					:default-checked-keys="[5]" :props="defaultProps">
				</el-tree>
				 -->
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini">
            <el-form-item :label="$t('juesemingcheng')" required>
              <el-input v-model="yt.editObj.name"></el-input>
            </el-form-item>
            <!-- 文字提示 -->
            <div>
              <span style="font-size: 2px; color: #989898;">{{ $t('qingzaixiafangxuanzecaidanyuanniu') }}</span>
            </div>
            <el-tabs>
              <!-- 搜索框 -->
              <el-form-item size="mini">
                <el-input :placeholder="$t('qingshuruguanjianci')" v-model="filterText"> </el-input>
              </el-form-item>
              <el-tab-pane label="Web">
                <el-tree ref="treeWeb" :data="menus[0]" show-checkbox node-key="id" :default-expand-all="false" :default-expanded-keys="expandKey(0)" :default-checked-keys="yt.editObj.menuIds" class="filter-tree" :filter-node-method="filterNode"> </el-tree>
              </el-tab-pane>
              <el-tab-pane label="App">
                <el-tree ref="treeApp" :data="menus[1]" show-checkbox node-key="id" :default-expand-all="false" :default-expanded-keys="expandKey(1)" :default-checked-keys="yt.editObj.menuIds" class="filter-tree" :filter-node-method="filterNode"> </el-tree>
              </el-tab-pane>
              <el-tab-pane label="Pad">
                <el-tree ref="treePad" :data="menus[2]" show-checkbox node-key="id" :default-expand-all="false" :default-expanded-keys="expandKey(2)" :default-checked-keys="yt.editObj.menuIds" class="filter-tree" :filter-node-method="filterNode"> </el-tree>
              </el-tab-pane>
            </el-tabs>
          </el-form>
        </div>

        <!--注意，el-dialog的slot不能写成#footer-->
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/customer/auth/role/update', beforeAddOrUpdate)" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>

      <template v-if="yt.editObj.action == 'fuzhi'">
        <!-- <el-tree :data="treeList(1)" show-checkbox node-key="id" :default-expanded-keys="[2, 3]"
					:default-checked-keys="[5]" :props="defaultProps">
				</el-tree>
				 -->
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini">
            <el-form-item :label="$t('juesemingcheng')" required>
              <el-input v-model="yt.editObj.name"></el-input>
            </el-form-item>
            <!-- 文字提示 -->
            <div>
              <span style="font-size: 2px; color: #989898;">{{ $t('qingzaixiafangxuanzecaidanyuanniu') }}</span>
            </div>
            <el-tabs>
              <!-- 搜索框 -->
              <el-form-item size="mini">
                <el-input :placeholder="$t('qingshuruguanjianci')" v-model="filterText"> </el-input>
              </el-form-item>
              <el-tab-pane label="Web">
                <el-tree ref="treeWeb" :data="menus[0]" show-checkbox node-key="id" :default-expand-all="false" :default-expanded-keys="expandKey(0)" :default-checked-keys="yt.editObj.menuIds" class="filter-tree" :filter-node-method="filterNode"> </el-tree>
              </el-tab-pane>
              <el-tab-pane label="App">
                <el-tree ref="treeApp" :data="menus[1]" show-checkbox node-key="id" :default-expand-all="false" :default-expanded-keys="expandKey(1)" :default-checked-keys="yt.editObj.menuIds" class="filter-tree" :filter-node-method="filterNode"> </el-tree>
              </el-tab-pane>
              <el-tab-pane label="Pad">
                <el-tree ref="treePad" :data="menus[2]" show-checkbox node-key="id" :default-expand-all="false" :default-expanded-keys="expandKey(2)" :default-checked-keys="yt.editObj.menuIds" class="filter-tree" :filter-node-method="filterNode"> </el-tree>
              </el-tab-pane>
            </el-tabs>
          </el-form>
        </div>

        <!--注意，el-dialog的slot不能写成#footer-->
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/customer/auth/role/create', beforeAddOrUpdate)" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_system_role_list',
  components: {},
  mixins: [],
  data() {
    return {
      menus: [],
      filterText: '',
      columns: [
        {
          label: 'juesemingcheng',
          prop: 'name'
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'gengxinren',
          prop: 'updateByObject.nickname'
        },
        {
          label: 'gengxinshijian',
          prop: 'updateTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.SELECT_URL = '/web/customer/auth/role/getCustomerRoleByIds';
      this.yt.SELECT_RESULT_KEY = 'data';
      this.yt.SELECT_ID = 'id';
      this.yt.SELECT_TITLE = 'name';
      this.yt.fixConditions.customerId = this.$attrs.customerId;
      this.yt.get(1);
      this.getAllPlatformMenus();
    }, 300);
  },
  watch: {
    filterText(val) {
      // 树结构 - 根据关键字搜索
      this.$refs.treeWeb.filter(val);
      this.$refs.treeApp.filter(val);
      this.$refs.treePad.filter(val);
    }
  },
  mounted() {},

  destroyed() {},

  computed: {
    expandKey() {
      return function(platform) {
        //目前只有两级，所以不用无限嵌套写法，单纯判断两级即可
        if (!this.menus[platform]) {
          return [];
        }
        let keys = [];
        keys = this.menus[platform].map(item => {
          return item.id;
        });
        return keys;
      };
    }
    // cascaderList() {
    // 	return function(platform) {
    // 		//目前只有两级，所以不用无限嵌套写法，单纯判断两级即可
    // 		if (!this.menus[platform - 1]) {
    // 			return []
    // 		}
    // 		return this.menus[platform - 1].map(item => {
    // 			let children
    // 			if (item.children) {
    // 				children = item.children.map(item2 => {
    // 					return {
    // 						label: this.$t(item2.code),
    // 						value: item2.id
    // 					}
    // 				})
    // 			}

    // 			return {
    // 				label: this.$t(item.code),
    // 				value: item.id,
    // 				children: this.yt.editObj.type == 1 ? null :
    // 				children, //如果是添加菜单，那么就只能一级，如果是添加按钮，就是二级
    // 			}
    // 		})
    // 	}

    // },
  },
  activated() {},
  methods: {
    beforeUpdate(params) {
      params.name = null;
      return params;
    },
    // 关键字过滤方法
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    beforeAddOrUpdate(params) {
      params.menuIds = [...this.$refs.treeWeb.getCheckedKeys(), ...this.$refs.treeApp.getCheckedKeys(), ...this.$refs.treePad.getCheckedKeys()];
      return params;
    },

    getAllPlatformMenus() {
      //先查询出所有平台的菜单
      this.menus = new Array(3);
      // 登录用户信息
      const currentUser = this.store.state.user;
      for (var i = 0; i < 3; i++) {
        (i => {
          this.http
            .get('web/system/auth/menu/allotTreeList', {
              params: {
                platform: i + 2
              }
            })
            .then(res => {
              this.menus[i] = res.data.map(item => {
                //二级
                let children1;
                if (item.children) {
                  children1 = item.children.map(item2 => {
                    //三级
                    let children2;
                    if (item2.children) {
                      children2 = item2.children.map(item3 => {
                        // 仅客户管理员才显示菜单备注
                        let remark = '';
                        if (currentUser && currentUser.type == 2) {
                          remark = item3.remark ? `(${item3.remark})` : '';
                        }
                        return {
                          label: this.$t(item3.code) + remark,
                          id: item3.id
                        };
                      });
                    }
                    // 仅客户管理员才显示菜单备注
                    let remark = '';
                    if (currentUser && currentUser.type == 2) {
                      remark = item2.remark ? `(${item2.remark})` : '';
                    }
                    return {
                      label: this.$t(item2.code) + remark,
                      id: item2.id,
                      children: children2
                    };
                  });
                }

                // 仅客户管理员才显示菜单备注
                let remark = '';
                if (currentUser && currentUser.type == 2) {
                  remark = item.remark ? `(${item.remark})` : '';
                }
                return {
                  label: this.$t(item.code) + remark,
                  id: item.id,
                  children: children1
                };
              });
            });
        })(i);
      }
    }
  }
};
</script>
